import React from 'react';
import ErrorsComponent from 'errors';
import DialogsComponent from 'dialog';
import ToastsComponent from 'toasts';
import { MainRouting } from './pages';
import { Tooltip } from 'react-tooltip';
import { useMount } from 'react-use';
import * as LoginManager from './reducers/ui/login';
import * as AppManager from './reducers/ui/app';

type Props = {};

export const App = (_props: Props) => {
	useMount(() => {
		setInterval(() => {
			LoginManager.tickSaveTimeout();
		}, 1000);

		AppManager.initViewportWidthTracker();
	});

	return (
		<>
			<MainRouting />
			<ErrorsComponent />
			<ToastsComponent />
			<DialogsComponent />
			<Tooltip id="rtip-1" style={{ zIndex: '9' }} />
		</>
	);
};
